"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _ModalSelectFoto = _interopRequireDefault(require("../ModalSelectFoto"));

var _uploadToS = require("../../utils/uploadToS3");

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormFotoPortada extends _react.default.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.onUploadPreviewFoto = this.onUploadPreviewFoto.bind(this);
    this.guardar = this.guardar.bind(this);
    this.onAddFoto = this.onAddFoto.bind(this);
    this.sendFiles = this.sendFiles.bind(this);
    this.state = {
      open: false,
      fotos: this.props.fotos,
      fotosGaleriaParaPortada: this.props.fotosGaleriaParaPortada
    };
  }

  onChangeRadio(value) {
    this.props.onChangeRadio(value.target.value);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fotos != this.props.fotos || prevProps.fotosGaleriaParaPortada != this.props.fotosGaleriaParaPortada) {
      this.setState({
        fotos: this.props.fotos,
        fotosGaleriaParaPortada: this.props.fotosGaleriaParaPortada
      });
    }
  }

  onAddFoto() {
    (0, _uploadToS.uploadFileToS3)(this.uploadInput, this.props.referencia, this.props.tipo, this.onUploadPreviewFoto, this.sendFiles, null);
  }

  onUploadPreviewFoto(url, name) {
    this.props.onChangeFoto({
      id: null,
      id_album: null,
      nombre: name,
      url
    });
  }

  sendFiles(files) {
    this.props.getFiles(files);
  }

  openModal(value) {
    this.setState({
      open: value
    });
  }

  guardar(foto) {
    this.openModal(false);
    this.props.onChangeFoto(foto);
  }

  render() {
    const {
      titulo,
      explicacion,
      fotoSelected
    } = this.props;
    const {
      open
    } = this.state;
    return (0, _react2.jsx)("div", null, (0, _react2.jsx)(_material.Grid, {
      container: true
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, titulo)), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "body1"
    }, explicacion)), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, this.state.fotos.map((portada, i) => {
      let cargando = !portada.id;
      return (0, _react2.jsx)("div", {
        key: i,
        css: _style.default.portada
      }, (0, _react2.jsx)("div", {
        css: _style.default.cuadradoGris
      }, (0, _react2.jsx)("div", {
        css: _style.default.radio
      }, (0, _react2.jsx)(_material.Radio, {
        checked: fotoSelected == portada.nombre,
        onChange: data => this.onChangeRadio(data),
        value: portada.nombre,
        name: `radio-button-${portada.id}`
      })), (0, _react2.jsx)("div", {
        css: cargando ? _style.default.containerFotoBlur : _style.default.containerFoto
      }, (0, _react2.jsx)("img", {
        css: _style.default.fotoPortada,
        src: portada.url,
        alt: "foto-portada"
      })), cargando ? (0, _react2.jsx)("div", {
        css: _style.default.progressContainer
      }, (0, _react2.jsx)(_material.CircularProgress, null)) : null));
    })), this.state.fotosGaleriaParaPortada.length ? (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)("div", {
      css: _style.default.portada
    }, (0, _react2.jsx)("div", {
      css: _style.default.cuadradoGris
    }, (0, _react2.jsx)("div", {
      css: _style.default.radio
    }, (0, _react2.jsx)(_material.Radio, {
      checked: false,
      onChange: () => this.openModal(true),
      value: "elegir",
      name: "radio-button-elegir"
    })), (0, _react2.jsx)("div", {
      css: _style.default.cuadrado,
      onClick: () => this.openModal(true)
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "subtitle2"
    }, "Elegir foto de galer\xEDa"))))) : null, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)("div", {
      css: _style.default.portada
    }, (0, _react2.jsx)("div", {
      css: _style.default.cuadradoGris
    }, (0, _react2.jsx)("div", {
      css: _style.default.radio
    }, (0, _react2.jsx)(_material.Radio, {
      checked: false,
      onChange: () => {
        document.getElementById('PicturePortadaUpload').click();
      },
      value: "subir",
      name: "radio-button-subir"
    })), (0, _react2.jsx)("div", {
      css: _style.default.cuadrado,
      onClick: () => {
        document.getElementById('PicturePortadaUpload').click();
      }
    }, (0, _react2.jsx)("input", {
      id: "PicturePortadaUpload",
      type: "file",
      onChange: this.onAddFoto,
      hidden: "hidden",
      ref: ref => {
        this.uploadInput = ref;
      },
      accept: "image/jpg, image/png, image/jpeg"
    }), (0, _react2.jsx)(_material.Typography, {
      variant: "subtitle2"
    }, "Subir una Foto")))))), (0, _react2.jsx)(_ModalSelectFoto.default, {
      titulo: "Seleccionar Portada",
      classes: _style.default,
      open: open,
      openModal: this.openModal,
      guardar: this.guardar,
      fotos: this.state.fotosGaleriaParaPortada,
      fotoSelected: fotoSelected
    }), (0, _react2.jsx)("hr", null));
  }

}

var _default = FormFotoPortada;
exports.default = _default;